import * as React from "react"
import { graphql } from "gatsby"
import Flink from '~/components/shared/flink'
import { Seo } from '~/components/shared/seo'
import { jnstyls, notBlank, imgSize } from '~/utils/helpers'

// import * as hstyles from "~/styles/home/home.module.scss"
// import {nd_fullwide, nd_fullbleedHero, nd_homeImage, nd_homeImg, nd_fullContent,
//         nd_homeTitle, nd_copyBody, nd_copyCta, nd_journTag} from "~/styles/home/home.module.scss"
import * as styles from "~/styles/pages/about.module.scss"
import * as hstyle from "~/styles/home/hero.module.scss"
import { himage, himg, journ_tag } from "~/styles/home/home-img.module.scss"
import { htitle, copy_body, copy_cta } from "~/styles/home/contents.module.scss"
import { cta_link } from "~/styles/app.module.scss"


const OurStory = ({ data: { ourStory } }) => {

  const page = ourStory.data

  return (
    <div className='nabout'>
      <section className={hstyle.hero}>
        {notBlank(page.hero_image) && (
          <img 
            className={jnstyls([styles.hero_img, styles.hero_desk])} 
            src={imgSize(page.hero_image,1200)} 
            alt="Buck Mason: Our Story" 
          />
        )}
        {notBlank(page.hero_image_mob) && (
          <img 
            className={jnstyls([styles.hero_img, styles.hero_mob])} 
            src={imgSize(page.hero_image_mob,900)} 
            alt="Buck Mason: Our Story" 
          />
        )}
        <h1 className={styles.title} dangerouslySetInnerHTML={{ __html: page.title }} />
      </section>

      <section className={styles.sec}>
        <div className={jnstyls([styles.block, styles.imgright])}>
          <div className={styles.block_copy}>
            {notBlank(page.story_title) && (
              <h2 className={styles.subtitle} dangerouslySetInnerHTML={{ __html: page.story_title }} />
            )}
            {notBlank(page.story_copy) && (
              <div className={styles.copy} dangerouslySetInnerHTML={{ __html: page.story_copy }} />
            )}
          </div>
          <div className={styles.block_image}>
            {notBlank(page.story_image) && (
              <>
                <img className={styles.block_img} src={imgSize(page.story_image,860)} alt={page.story_caption} />
                {notBlank(page.story_caption)&& (
                  <div className={styles.block_caption} dangerouslySetInnerHTML={{ __html: page.story_caption }} />
                )}
              </>
            )}
          </div>
        </div>
      </section>

      {notBlank(page.story_title2) && (
        <section className={styles.sec}>
          <div className={styles.block}>
            <div className={styles.block_image}>
              {notBlank(page.story_image2) && (
                <>
                  <img className={styles.block_img} src={imgSize(page.story_image2,860)} alt={page.story_caption2} />
                  {notBlank(page.story_caption2) && (
                    <div className={styles.block_caption} dangerouslySetInnerHTML={{ __html: page.story_caption2 }} />
                  )}
                </>
              )}
            </div>
            <div className={styles.block_copy}>
              {notBlank(page.story_title2) && (
                <h2 className={styles.subtitle} dangerouslySetInnerHTML={{ __html: page.story_title2 }} />
              )}
              {notBlank(page.story_copy2) && (
                <div className={styles.copy} dangerouslySetInnerHTML={{ __html: page.story_copy2 }} />
              )}
            </div>
          </div>
        </section>
      )}

      {notBlank(page.story_title3) && (
        <section className={styles.sec}>
          <div className={jnstyls([styles.block, styles.imgright])}>
            <div className={styles.block_copy}>
              {notBlank(page.story_title3) && (
                <h2 className={styles.subtitle} dangerouslySetInnerHTML={{ __html: page.story_title3 }} />
              )}
              {notBlank(page.story_copy3) && (
                <div className={styles.copy} dangerouslySetInnerHTML={{ __html: page.story_copy3 }} />
              )}
            </div>
            <div className={styles.block_image}>
              {notBlank(page.story_image3) && (
                <>
                  <img className={styles.block_img} src={imgSize(page.story_image3,860)} alt={page.story_caption3} />
                  {notBlank(page.story_caption3) && (
                    <div className={styles.block_caption} dangerouslySetInnerHTML={{ __html: page.story_caption3 }} />
                  )}
                </>
              )}
            </div>
          </div>
        </section>
      )}

      {(notBlank(page.story_factory_title) && notBlank(page.story_factory_image)) && (
        <section className={jnstyls([styles.sec, hstyle.wide, styles.wide])} style={{marginTop: '1em', borderTop: 0}}>
          <Flink href="/pages/buck-mason-knitting-mills" style={{textDecoration: 'none'}}>
            <div className={hstyle.content}>
              <div className={himage}>
                <img 
                  className={himg} 
                  src={imgSize(page.story_factory_image,1100)} 
                  alt="A look at our factory" 
                  height="633" 
                  width="1200" 
                />
              </div>
              <div className={hstyle.over_cont}>
                <div className={styles.overlay}>
                  <div className={jnstyls([htitle])} dangerouslySetInnerHTML={{ __html: page.story_factory_title }} />
                  <div className={jnstyls([copy_body, styles.copy_body])} dangerouslySetInnerHTML={{ __html: page.story_factory_copy }} />
                  <div className={copy_cta}>
                    <div style={{display: 'inline-block'}} className={cta_link}><span>Learn More</span></div>
                  </div>
                </div>
              </div>
            </div>
          </Flink>
        </section>
      )}

      <section className={styles.sec}>
        <div className={jnstyls([styles.block, styles.block_stores])}>
          <div className={styles.block_image}>
            {notBlank(page.stores_image) && (
              <img className={styles.block_img} src={imgSize(page.stores_image,860)} alt="Our Stores" />
            )}
            <div className={journ_tag}>Our Stores</div>
          </div>
          <div className={styles.block_copy}>
            {notBlank(page.stores_title) && (
              <h2 className={styles.subtitle} dangerouslySetInnerHTML={{ __html: page.stores_title }} />
            )}
            {notBlank(page.stores_copy) && (
              <div className={styles.copy}>
                <p dangerouslySetInnerHTML={{ __html: page.stores_copy }} />
                {notBlank(page.stores_cta) && (
                  <p><Flink href="/pages/our-stores" className={cta_link}><span>{page.stores_cta}</span></Flink></p>
                )}
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  )
}
export default OurStory


export const Head = ({ data: { ourStory } }) => (
  <Seo 
    title={'Our Story'}
    description={ourStory.data.story_copy}
    image={ourStory.data.metaimg}
    url={`/pages/our-story`}
  />
)



export const pageQuery = graphql`
  {
    ourStory: contentPage(type: {eq: "AboutStory"}) {
      data
    }
  }
`;

